/* eslint-disable react/display-name */
/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Text,
  Textarea,
} from '@mybridge/ui';
import { forwardRef, useContext, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { MyProfileContext } from '../context';
import { EMPLOYMENT_CHOICES } from 'v4/lib/data';
import { CompaniesDropdown } from 'v4/components/company-dropdown';
import { CountryDropdown } from 'v4/components/country-dropdown';
import { DateSelect } from 'v4/components/date-select';
import { IndustryDropdown } from 'v4/components/industry-dropdown';
import { CityStateCountryDropdown } from 'v4/components/city-state-country-dropdown';
import { formatLocation } from 'v4/lib/commons';
import moment from 'moment';
import { AutoSuggestLocationFields } from 'v4/components/auto-suggest-location';
import { useDisclosure } from '@mybridge/ui';
import { EarthGlobeIcon, OnlyMeLockIcon, TeamIcon } from '@mybridge/icons';
import { CreateAudiencePermissionModal } from '../audience-modal-create';
import { Box } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { getUserProfileInfo } from 'v4/store/actions/user-profile.actions';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const MyProfileExperienceModal = forwardRef(
  ({ noHeadline, nonModal, ...props }, ref) => {
    const {
      experienceDisc,
      addExperience,
      addExperienceLoading,
      selectedExperience,
      updateExperience,
      setSelectedExperience,
      removeExperience,
      removeExperienceLoading,
      isDateAfter,
      setPermissionValue,
      setCurrentPermissionValue
    } = useContext(MyProfileContext);
    const audienceCreateDisc = useDisclosure();
    const dispatch=useDispatch()
    const { t } = useTranslator();
    const {formatNumber}=useNumberFormatter();
    const [audienceValue, setAudienceValue] = useState(1);
    const experience = {
      ...(selectedExperience ?? {}),
      start_date: {
        month: parseInt(selectedExperience?.start_month ?? '0'),
        year: selectedExperience?.start_year,
      },
      end_date: {
        month: parseInt(selectedExperience?.end_month ?? '0'),
        year: selectedExperience?.end_year,
      },
      location: {
        city: selectedExperience?.city,
        state: selectedExperience?.state_region,
        country: selectedExperience?.country,
      },
    };

    const {
      register,
      handleSubmit,
      control,
      watch,
      setError,
      clearErrors,
      setValue,
      formState: { errors },
    } = useForm({
      defaultValues: experience ?? {},
    });

    const onSubmit = async (form) => {
      const payload = {
        ...(form ?? {}),
        start_month: form?.start_date?.month,
        start_year: form?.start_date?.year,
        end_month: form?.end_date?.month,
        end_year: form?.end_date?.year,
        profile_headline: form?.title,
        location: formatLocation(form?.location),
        city: form?.location?.city,
        state_region: form?.location?.state,
        country: form?.location?.country,
        postal:form?.location?.postal,
        audience: audienceValue,
      };
      if (selectedExperience?.id) {
        await updateExperience({
          id: selectedExperience?.id,
          ...(payload ?? {}),
        }).then(()=>{
          dispatch(getUserProfileInfo())
        });

        setSelectedExperience();
      } else {
        await addExperience(payload).then(()=>{
          dispatch(getUserProfileInfo())
        });
      }
    };

    const onClose = () => {
      experienceDisc?.onClose();
      setSelectedExperience?.(null);
    };

    const renderPermissionSwitch = (param) => {
      switch (param) {
        case 1:
          return {
            icon: <EarthGlobeIcon width="16px" height="16px" />,
            text: t('profileDetails.public') || 'Public',
          };
        case 2:
          return {
            icon: <TeamIcon width="16px" height="16px" />,
            text: t('profileDetails.myNetwork') || 'myNetwork',
          };
        case 3:
          return {
            icon: <OnlyMeLockIcon width="16px" height="16px" />,
            text: t('profileDetails.onlyMe') || 'Only me',
          };
        default:
          return {
            icon: <EarthGlobeIcon width="16px" height="16px" />,
            text: t('profileDetails.public') || 'Public',
          };
      }
    };
    return (
      // <Modal size="xl" {...(experienceDisc ?? {})} onClose={onClose}>
      //   <ModalOverlay />
      //   <ModalContent>

      //   </ModalContent>
      // </Modal>
      <>
        <Heading
          fontSize="18px"
          color="brandPrimary.500"
          fontWeight="400"
          mb={4}
        >
          {t('profileExperience.experience') || "Experience"}
        </Heading>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={6}>
            <FormControl isInvalid={errors?.title} >
            <FormLabel
                position={'absolute'} // Float label when value exists
                top={'-9px'} // Move the label up when there's text
                left="12px"
                fontSize={'sm'} // Change font size when floating
                transition="0.2s ease-in-out" // Smooth transition
                bg="white" // To avoid overlap with the border or background
                px={1} // Padding to give space around the label
                zIndex={2} // Ensure the label stays above the Textarea
                pointerEvents="none" // Disable pointer events on the label
              >
                {t('profileExperience.position') || "Position"}*
              </FormLabel>
              <Input
                defaultValue={''}
                {...register('title', { required: true })}
                placeholder=""
                bg="white" // Set background color to white
              />
              <FormErrorMessage>{t('profileExperience.positionRequired') || "Position is required"}</FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={errors?.employment_type} variant="floating">
              <Select
                {...register('employment_type', { required: false })}
                // placeholder="Select"
                variant="whiteInput"
                h="60px"
              >
                {EMPLOYMENT_CHOICES.map((ec, ecIndex) => (
                  <option value={ec.value} key={ecIndex}>
                    {t(ec.translationKey)}
                  </option>
                ))}
              </Select>
              <FormLabel>{t('profileExperience.employmentType') || "Employment Type"}*</FormLabel>
              <FormErrorMessage>{t('profileExperience.employmentTypeRequired') || "Employment type is required"}</FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={errors?.company_name}>
              <Controller
                control={control}
                render={({ field }) => (
                  <CompaniesDropdown
                    allowCreate
                    {...field}
                    onChange={(item) => field?.onChange?.(item?.name)}
                    defaultValue={experience?.company_name}
                    variant="whiteInput"
                    textTransform="capitalize"
                  >
                    {(input) => (
                      <Input
                        {...(input ?? {})}
                        onClick={(e) => input?.disc?.onOpen?.()}
                        onChange={(e) => input?.onChange(e.target.value)}
                        placeholder={t('profileDetails.typeToSearch') || 'Type to search...'}
                        variant="whiteInput"
                      />
                    )}
                  </CompaniesDropdown>
                )}
                rules={{ required: true }}
                name="company_name"
              />
               <FormLabel
                position={'absolute'} // Float label when value exists
                top={'-9px'} // Move the label up when there's text
                left="12px"
                fontSize={'sm'} // Change font size when floating
                transition="0.2s ease-in-out" // Smooth transition
                bg="white" // To avoid overlap with the border or background
                px={1} // Padding to give space around the label
                zIndex={2} // Ensure the label stays above the Textarea
                pointerEvents="none" // Disable pointer events on the label
              >
               {t('profileExperience.companyName') || "Company Name"}*
              </FormLabel>
              <FormErrorMessage>{t('profileExperience.companyNameRequired') || "Company name is required"}</FormErrorMessage>
            </FormControl>

            <FormControl isInvalid={errors?.location}>
              {/* <FormLabel>Country Region</FormLabel> */}
              <Controller
                control={control}
                render={({ field }) => (
                  // <CountryDropdown
                  //   placeholder="Type to search..."
                  //   {...field}
                  // />
                  <AutoSuggestLocationFields
                    controlFor="job"
                    countryLabel={t('profileExperience.countryRegion') || "Country/Region"}
                    cityStateLabel={t('profileExperience.cityDistrict') || "City/District"}
                    noIcon
                    {...field}
                  />
                  // <CityStateCountryDropdown />
                )}
                rules={{ required: false }}
                name="location"
              />
              <FormErrorMessage>{t('profileExperience.countryRequired') || "Country is required"}</FormErrorMessage>
            </FormControl>

            <HStack alignItems="flex-start">
              <FormControl isInvalid={errors?.start_date}>
                <FormLabel>{t('profileExperience.startDate') || "Start date"}*</FormLabel>

                {/* Add a Box or div wrapper around the Controller to apply spacing */}
                <Box mt={3}>
                  {' '}
                  {/* mt adds space (margin-top) between the lab  el and the Controller */}
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <DateSelect variant="floating" {...field} />
                    )}
                    rules={{ required: true }}
                    name="start_date"
                  />
                </Box>

                <FormErrorMessage>{t('profileExperience.startDateRequired') || "Start date is required"}</FormErrorMessage>
              </FormControl>

              {watch('currently_working') ? (
                ''
              ) : (
                <FormControl isInvalid={errors?.end_date}>
                  <FormLabel>{t('profileExperience.endDate') || "End date"}*</FormLabel>
                  <Box mt={3}>
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <DateSelect variant="floating" {...field} minDate={watch('start_date')} />
                    )}
                    rules={{
                      required: true,
                      validate() {
                        return isDateAfter(
                      

                         formatNumber(watch('start_date')?.month ?? 0),
                          formatNumber(watch('start_date')?.year ?? 0),
                          formatNumber(watch('end_date')?.month ?? 0),
                          formatNumber(watch('end_date')?.year ?? 0)
                        );
                      },
                    }}
                    name="end_date"
                  />
                  </Box>
                  <FormErrorMessage>{t('profileExperience.enterValidEndDate') || "Enter a valid end date"}</FormErrorMessage>
                </FormControl>
              )}
            </HStack>
            <FormControl>
              <Checkbox {...register('currently_working')}>
              {t('profileExperience.currentlyWorkingHere') || "I am currently working here"}
              </Checkbox>
            </FormControl>
            <FormControl isInvalid={errors?.industry}>
              <FormLabel
                position={'absolute'} // Float label when value exists
                top={'-12px'} // Move the label up when there's text
                left="12px"
                fontSize={'md'} // Change font size when floating
                transition="0.2s ease-in-out" // Smooth transition
                bg="white" // To avoid overlap with the border or background
                px={1} // Padding to give space around the label
                zIndex={2} // Ensure the label stays above the Textarea
                pointerEvents="none" // Disable pointer events on the label
              >
                {t('profileExperience.industry') || "Industry"}
              </FormLabel>
              <Controller
                control={control}
                render={({ field }) => (
                  <IndustryDropdown
                    value={field.value} // Pass the current field value
                    defaultValue={experience?.industry || selectedExperience?.industry}
                    field="name"
                    {...field}
                    variant="whiteInput"
                    placeholder={t('profileDetails.typeToSearch') || 'Type to search...'}
                    onChange={(selectedIndustry) => {
                      // Extract only the name if it's an object, otherwise use as-is
                      const industryName = selectedIndustry?.name || selectedIndustry;
                      field.onChange(industryName);
                    }}
                  />
                )}
                rules={{ required: false }}
                name="industry"
              />

              <FormErrorMessage>{t('profileExperience.industryRequired') || "Industry is required"}</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={!!errors?.desc}>
              <FormLabel
                htmlFor="desc"
                position={'absolute'} // Float label when value exists
                top={'-10px'} // Move the label up when there's text
                left="12px"
                fontSize={'sm'} // Change font size when floating
                transition="0.2s ease-in-out" // Smooth transition
                bg="white" // To avoid overlap with the border or background
                px={1} // Padding to give space around the label
                zIndex={2} // Ensure the label stays above the Textarea
                pointerEvents="none" // Disable pointer events on the label
              >
                {t('profileExperience.description') || "Description"}
              </FormLabel>
              <Textarea
                id="desc"
                variant="outline"
                placeholder={t('profileExperience.typeYourDescription') || "Type your description here..."}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length > 2048) {
                    // setError('desc', {
                    //   type: 'manual',
                    //   message: 'Max length of 2048 characters exceeded',
                    // });
                  } else {
                    clearErrors('desc');
                    setValue('desc', value, { shouldValidate: true });
                  }
                }}
                value={watch('desc') ?? ''} // Watch to get the current value
              />
              <FormHelperText as={HStack} justifyContent="flex-end">
                <Text>
                  {formatNumber(watch('desc')?.length ?? 0)}/{formatNumber(2048)}
                </Text>
              </FormHelperText>
              <FormErrorMessage>{errors.desc?.message}</FormErrorMessage>
            </FormControl>
          </Stack>
          <HStack flex={1} mt={4}>
            <HStack flex={1} justifyContent="flex-start">
              <Button
              borderRadius="50px"
                leftIcon={renderPermissionSwitch(audienceValue)?.icon}
                type="button"
                onClick={() => {
                  audienceCreateDisc.onOpen();
                }}
              >
                {renderPermissionSwitch(audienceValue)?.text}
              </Button>
              {selectedExperience?.id ? (
                <Button
                borderRadius="50px"
                  onClick={(e) => removeExperience(selectedExperience)}
                  isLoading={removeExperienceLoading}
                  color="red.500"
                  variant="ghost"
                >
                  {t('buttons.delete') || 'Delete'}
                </Button>
              ) : (
                ''
              )}
            </HStack>
            <HStack flex={1} justifyContent="flex-end">
              <Button
              borderRadius="50px"
                onClick={(e) => {
                  experienceDisc?.onClose?.();
                  setSelectedExperience();
                }}
                variant="secondary"
              >
                {t('buttons.cancel') || 'Cancel'}
              </Button>
              <Button
              borderRadius="50px"
                isLoading={addExperienceLoading}
                type="submit"
                variant="primary"
              >
                {t('buttons.save') || 'Save'}
              </Button>
            </HStack>
          </HStack>
        </form>
        {audienceCreateDisc?.isOpen ? (
          <CreateAudiencePermissionModal
            {...audienceCreateDisc}
            setPermissionValue={(e) => {
              setAudienceValue(e);
              setCurrentPermissionValue(e);
            }}
            
          />
        ) : (
          ''
        )}
      </>
    );
  }
);
